import { httpServer as http } from "@/lib/axios";
import { httpServer as downFilehttp } from "@/lib/downFileAxios";

export default {
  namespaced: true,
  state: {
    expressFeesTabType: "summary", // summary or detail
    detailMonth: null,
    k1: "",
    status: ""
  },
  mutations: {
    toggleExpressFeesTab(state, { type, detailMonth, k1, status }) {
      state.expressFeesTabType = type;
      state.detailMonth = detailMonth || null;
      state.status = status || "";
    },
    setDetailMonth(state, data) {
      state.detailMonth = data || null;
    },
    setStatus(state, data) {
      state.status = data || "";
    }
  },
  actions: {


    // 统计页列表
    async queryCouponStatistics({ rootState }, params = {}) {
      const data = await http("/coupon/manage/queryCouponStatistics", params);

      return data.data || { list: [], total: 0 };
    },
    // 详情列表
    async queryCouponStatisticsDetailList({ rootState }, params = {}) {
      const data = await http("/coupon/manage/queryCouponStatisticsDetailList", params);

      return data.data || { list: [], total: 0 };
    },
    // 根据优惠券编码批量查询优惠券基本信息
    async queryCouponBaseInfoList({ rootState }, params = {}) {
      const data = await http("/coupon/manage/findCouponBaseInfoList", params);

      return Array.isArray(data.data)
        ? data.data
        : (data.data && data.data.list) || [];
    },
    // 统计导出明细
    async exportCouponStatistics({ rootState }, params = {}) {

      const data: any = await downFilehttp({
        url: "/coupon/manage/exportCouponStatistics",
        params
      });


      return data;
    },
    // 导出明细
    async exportCouponStatisticsDetail({ rootState }, params = {}) {
      await http("/coupon/manage/coupon-statistics-detail/export", params);
    },
  }
};
